// extracted by mini-css-extract-plugin
module.exports = {"myHeader":"App_myHeader__1M1IX","footer":"App_footer__nlmoo","title":"App_title__N6j07","subtitle":"App_subtitle__wna1I","height1000":"App_height1000__2wRkY"};